import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { useSupportSession } from '@/contexts/SupportSessionContext';
export function SystemStatusRoute({children}:{children:ReactNode}) {
 const {status,session}=useAuth(); const {isSupportSession}=useSupportSession();
 const [verified,setVerified]=useState<string|null>(null); const [denied,setDenied]=useState(false);
 const identity=session?.user.id; const token=session?.access_token;
 useEffect(()=>{let active=true;setVerified(null);setDenied(false);
  if(status!=='authed'||!identity||!token||isSupportSession)return;
  supabase.functions.invoke('sa-system-status?access=1',{method:'GET'}).then(({data,error})=>{if(active){if(!error&&data?.authorized===true)setVerified(token);else setDenied(true);}}).catch(()=>{if(active)setDenied(true);});
  return()=>{active=false};
 },[status,identity,token,isSupportSession]);
 if(isSupportSession)return <Navigate to="/dashboard" replace/>;
 if(status==='unauthed')return <Navigate to="/auth" replace/>;
 if(denied)return <Navigate to="/dashboard" replace/>;
 if(status!=='authed'||!token||verified!==token)return <div role="status">Verifying access…</div>;
 return <>{children}</>;
}
